import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

export default function CategoryHeader({ left, right, children }) {
    return (
        <div className="category-header">
            {left ? <span className="left">{left}</span> : null}
            {right ? <span className="right">{right}</span> : null}
            {children}
        </div>
    )
}

CategoryHeader.propTypes = {
    left: PropTypes.node,
    right: PropTypes.node,
}